import { Befehl } from '../models'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 3 has empty fields.
 *
 * Befehl 3 has no special business rules beyond checking if fields are empty,
 * so it uses the generic empty field check.
 *
 * Note: Befehl 3 only has checkbox fields (auftrag enables), which are never
 * considered empty, so this will always return false unless the structure changes.
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl3EmptyFields(befehl: Befehl): boolean {
  return hasBefehlGenericEmptyFields(befehl)
}
